module.exports = __webpack_public_path__ + "static/template_noren-0e846b137e403ca898422dbcf9c5d902.png";